const AT = require("../core/vault/ActionTypes");
const UpdateOffice = require("./vault/UpdateOffice");

const initialize = function(vault, updater) {
	UpdateOffice.augment(updater);
	vault.dispatchNow({type: AT.OFFICE_INITIAL});
};

const {PageConfirmEmail} = require("./PageConfirmEmail");
const {PageLoggedInHome} = require("./PageLoggedInHome");

module.exports = {
	initialize,

	TopBar: require("./TopBar"),
	BottomBar: require("./BottomBar"),
	ChangePasswordModal: require("./modals/ChangePasswordModal"),
	EmailModal: require("./modals/EmailModal"),
	ErrorModal: require("./modals/ErrorModal"),
	BrowserModal: require("./modals/BrowserModal"),
	DisconnectModal: require("./modals/DisconnectModal"),
	CartModal: require("./modals/CartModal"),
	MessageModal: require("./modals/MessageModal"),
	CancelSubscriptionModal: require("./modals/CancelSubscriptionModal"),
	ConfirmModal: require("./modals/ConfirmModal"),
	PageConfirmEmail: PageConfirmEmail,
	PageLoggedInHome: PageLoggedInHome,
	PageResources: require("./PageResources"),
	PageCheckout: require("./checkout/PageCheckout"),
	PageChalkboard: require("./PageChalkboard"),
	PageMailingList: require("./PageMailingList"),
	PageEnableAutoRenew: require("./PageEnableAutoRenew"),
	PageAccountSetup: require("./PageAccountSetup"),
	PagePrivacyAndTerms: require("./PagePrivacyAndTerms"),
	PageRedeemSubscription: require("./redeemSubscription/PageRedeemSubscription"),

	// Office CMS Info Pages:
	PageInfo: require("./PageInfo"),

	OpsCart: require("./vault/OpsCart"),
};
